export default "__VITE_ASSET__ada20b6b__"